import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { StockWarehouseContent } from '../../../../shared/models';
import { StockInformationWarehouseState } from '../../store/stock-information-warehouse.reducers';
import {
  StockInformationWarehouseRequestAction,
  StockInformationWarehouseResetAction
} from '../../store/stock-information.actions';
import {
  selectAllStockWarehouseList,
  selectStockWarehouseList,
  selectStockWarehouseListCriteria
} from '../../store/stock-information.selector';
import { StockInformationStates } from '../../store/stock-information.states';

@Component({
  selector: 'app-stock-warehouse',
  templateUrl: './stock-warehouse.component.html',
  styleUrls: ['./stock-warehouse.component.scss']
})
export class StockWarehouseComponent extends OnDestroyMixin implements OnInit, OnDestroy {
  @Input() warehouse: string;
  @Input() articleNo: string;

  public dateFormat = environment.dateFormat;
  public dateTimeDisplay = environment.dateTimeDisplay;
  public criteriaObject: any;
  public currentPage: number;
  public pageSize: number;
  resultWarehouseList$: Observable<StockWarehouseContent[]>;
  listWarehouseState$: Observable<StockInformationWarehouseState>;
  private localStore: Observable<any>;

  assetPath = environment.assetPath;

  constructor(protected readonly store: Store<StockInformationStates>) {
    super();
  }

  ngOnInit() {
    this.setInitialCriteriaObject();
    this.initialData();

    this.localStore = this.store.pipe(untilComponentDestroyed(this));
    this.localStore
      .pipe(select(selectStockWarehouseListCriteria))
      .subscribe(criteriaObject => (this.currentPage = criteriaObject.page + 1));

    this.search();
  }

  initialData() {
    this.resultWarehouseList$ = this.store.select(selectAllStockWarehouseList);
    this.listWarehouseState$ = this.store.select(selectStockWarehouseList);
  }
  setInitialCriteriaObject() {
    this.pageSize = 20;

    this.criteriaObject = {
      page: 0,
      size: 20
    };
  }

  search() {
    this.store.dispatch(
      new StockInformationWarehouseRequestAction({
        criteria: this.criteriaObject,
        warehouse: this.warehouse,
        articleNo: this.articleNo
      })
    );
  }

  setFirstPage() {
    this.currentPage = 1;
  }

  onChangePage(event: any) {
    this.criteriaObject = {
      ...this.criteriaObject,
      page: event.page - 1
    };
    this.search();
  }

  onChangeRowPerPage(value: string) {
    this.setFirstPage();
    this.pageSize = Number(value);
    this.criteriaObject = {
      ...this.criteriaObject,
      size: Number(value),
      page: 0
    };
    this.search();
  }

  ngOnDestroy(): void {
    this.store.dispatch(new StockInformationWarehouseResetAction());
  }
}
